import { useCatalogFavorites } from "./use-catalog-favorites"
import { useCatalogPopular } from "./use-catalog-popular"
import { useCatalogRecent } from "./use-catalog-recent"
import { useCatalogRecomended } from "./use-catalog-recomended"

export const useCatalogAllTop = () => {
  const favoriteGames = useCatalogFavorites()
  const popularGames = useCatalogPopular()
  const recentGames = useCatalogRecent()
  const recomendedGames = useCatalogRecomended()

  const isLoading = favoriteGames.isLoading || popularGames.isLoading || recentGames.isLoading || recomendedGames.isLoading
  const error = favoriteGames.error || popularGames.error || recentGames.error || recomendedGames.error

  return {
    favoriteGames:  favoriteGames.games,
    popularGames: popularGames.games,
    recentGames: recentGames.games,
    recomendedGames: recomendedGames.games,
    error,
    isLoading,
    error,
    isLoading,
  }
}